import { LoraSelect } from "@components/lora-select";
import { Blockquote, Heading, TextArea } from "@radix-ui/themes";
import { useTranslation } from "react-i18next";
import { AdvancedMode } from "../components/advanced-mode";
import { ModeBaseProps } from "./types";

export const ClassicMode = ({
  promptTxt,
  setPromptTxt,
  style,
  setStyle,
}: ModeBaseProps & {
  promptTxt: string;
  setPromptTxt: (value: string) => void;
  style: string;
  setStyle: (value: string) => void;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <div className="space-y-2">
        <Heading size="3">{t("camera.form.prompt.title")}</Heading>
        <TextArea
          placeholder={t("camera.form.prompt.placeholder")}
          size="3"
          resize={"vertical"}
          value={promptTxt}
          onChange={(e) => setPromptTxt(e.target.value)}
        />
        <Blockquote size="2">{t("camera.form.prompt.description")}</Blockquote>
      </div>
      <AdvancedMode startOpen={style !== "none"}>
        <div className="space-y-2">
          <Heading size="3">{t("camera.form.style")}</Heading>
          <LoraSelect value={style} onChange={setStyle} type="style" canEdit />
        </div>
      </AdvancedMode>
    </>
  );
};
